
 <div class="caroussel  mb-4"> 
  <div class="swiper-container">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div class="swiper-slide">
          <div class="text1 h1 mb-2 color1">La plateforme professionnelle <br> et participative <br> des jeunes talents.</div>
        </div>
        <div class="swiper-slide">
          <div class="text1 h1 mb-2 color1"> La solution 360° pour dénicher <br> et mobiliser la crème des jeunes talents.</div>
        </div>
        <div class="swiper-slide">
          <div class="text1 h1 mb-2 color1">Le 1er média social <br> qui valorise  et rémunère  ses utilisateurs.</div>
        </div>
        <div  class="swiper-slide">
          <div class="text1 h1 color1"> Lancez des challenges et mobilisez toute notre communauté pour vos projets. </div>
        </div>
        <div  class="swiper-slide">
          <div class="text1 h1 mb-2 color1"> Accédez aux meilleurs profils grâce à notre système innovant d'acquisition de talent.</div>
      </div>
      <div  class="swiper-slide">
          <div class="text1 h1 mb-2 color1"> Renforcez votre présence <br> auprès  d'une vaste communauté de jeunes talents.</div>
      </div>
      <div  class="swiper-slide">
          <div class="text1 h1 color1"> Étudiants, jeunes diplômés, jeunes talents expérimentés, vivez une expérience candidat unique.</div>
      </div>
      <div  class="swiper-slide">
          <div class="text1 h1 color1">Entreprises ambitieuses en quête de talents internes ou externes, rejoignez-nous.</div>
      </div>
        ...
      </div>
      <!-- If we need pagination -->
      <div class="swiper-pagination"></div>
    
     
    
    </div>
    <div class="text2 h5 colorGold text-center">Talent acquistion | Crowdsourcing | Social network</div>
</div>